import { Grid2 } from '@mui/material';
import React from 'react';
import ComponentTitle from './ComponentTitle';

const DEFAULT_HEADLINE_ITEMS = [];
function PageWithTitle({
    children,
    title,
    headline = DEFAULT_HEADLINE_ITEMS,
    // Wide headlines (e.g. filter rows) opt into dropping full-width below the title
    // on mobile; compact ones (buttons) stay inline on the right by default.
    stackHeadline = false,
    // Keep a compact headline on the title row even at narrow widths (nowrap),
    // instead of letting it wrap below. Use only for small icon/button groups.
    inlineHeadline = false,
}) {
    const hasHeadline = Array.isArray(headline) ? headline.length > 0 : Boolean(headline);
    return (
        <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12 }}>
                <Grid2
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}
                    wrap={inlineHeadline ? 'nowrap' : 'wrap'}
                >
                    <Grid2 sx={{ textAlign: 'left' }}>
                        <ComponentTitle variant="h4" title={title} />
                    </Grid2>
                    {hasHeadline &&
                        (stackHeadline ? (
                            <Grid2 size={{ xs: 12, md: 'auto' }}>{headline}</Grid2>
                        ) : (
                            <Grid2>{headline}</Grid2>
                        ))}
                </Grid2>
            </Grid2>
            {children}
        </Grid2>
    );
}

export default PageWithTitle;
